import DashboardPage from "@/pages/dashboard";
import HomePage from "@/pages/home/home-page";
import UsersPage from "@/pages/user-page";
import { RouteType } from "../types";
import { route } from "../utils";

export const dashboardRoutes: Record<string, RouteType> = {
  home: route("/", HomePage),
  dashboard: route("/dashboard", DashboardPage),
  users: route("/users", UsersPage),
};